import { useState, useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { GrowlMessage } from '@campgladiator/cgui-core.molecules.growl-message'
import {
  LoginContainer,
  LoginFooter,
  LoginHeader,
  SignUpCard,
  RegistrationCheck,
} from '..'
import { LOGIN_ERROR } from '../../../common/utility'
import {
  loginAction,
  authorizeUser,
  getUserDetails,
  authLogout,
} from '../../../redux/features/authActions'
import { getChallengesProgress } from '../../../redux/features/challengeActions'

const Login = () => {
  const [loginFormData, setLoginFormData] = useState({
    email: '',
    password: '',
  })
  const [isLoginError, setIsLoginError] = useState(false)
  const { isLoggedIn, error: loginError } = useSelector(
    (state) => state.authReducer,
  )
  const [isLoading, setIsLoading] = useState(false)
  const { hasPreviousChallenges } = useSelector(
    (state) => state.challengeReducer,
  )
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const onInputChange = ({ target: { value, id } }) => {
    setLoginFormData({
      email: id === 'email' ? value.toString().trim() : loginFormData.email,
      password: id === 'password' ? value.toString() : loginFormData.password,
    })
    setIsLoginError(false)
  }

  const onSubmit = async (e) => {
    setIsLoading(true)
    e.preventDefault()
    try {
      await dispatch(loginAction(loginFormData))
      await dispatch(authorizeUser())
      await dispatch(getUserDetails())
      await dispatch(getChallengesProgress())
    } catch (error) {
      setIsLoginError(true)
    } finally {
      setIsLoginError(false)
      setIsLoading(false)
    }
  }

  const onBackToLogin = useCallback(() => {
    dispatch(authLogout())
    setLoginFormData({
      email: '',
      password: '',
    })
  }, [dispatch])

  useEffect(() => {
    if (loginError) {
      setIsLoginError(true)
    }
  }, [loginError])

  useEffect(() => {
    if (isLoggedIn && hasPreviousChallenges) {
      navigate('/')
    }
  }, [isLoggedIn, hasPreviousChallenges, navigate])

  return (
    <>
      <GrowlMessage
        title="Heads Up:"
        isVisible={isLoginError}
        onClick={() => setIsLoginError(false)}
      >
        {LOGIN_ERROR}
      </GrowlMessage>
      <section className="login">
        <div className="login-widget">
          <div className="login-widget__header">
            <LoginHeader />
          </div>
          <div className="login-widget__content">
            {(!isLoggedIn || isLoading) && (
              <>
                <LoginContainer
                  formData={loginFormData}
                  inputChange={onInputChange}
                  onLoginSubmit={onSubmit}
                  isLoading={isLoading}
                />
                <SignUpCard />
              </>
            )}
            {isLoggedIn && !hasPreviousChallenges && !isLoading && (
              <RegistrationCheck backToLogin={onBackToLogin} />
            )}
          </div>
          <div className="login-widget__footer">
            <LoginFooter />
          </div>
        </div>
      </section>
    </>
  )
}

export default Login
